import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
// import { useTheme } from '@mui/material/styles';
import { Box, Link } from '@mui/material';
// import Image from '../image';

// ----------------------------------------------------------------------

const ABLogo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  // const theme = useTheme();

  // const PRIMARY_LIGHT = theme.palette.primary.light;

  // const PRIMARY_MAIN = theme.palette.primary.main;

  // const PRIMARY_DARK = theme.palette.primary.dark;

  // OR using local (public folder)
  // -------------------------------------------------------
  const logo = (
    <Box
      component="img"
      src="/logo/ab_logo_full.svg"
      sx={{ width: 40, height: 40, cursor: 'pointer', ...sx }}
    />
  );


  if (disabledLink) {
    return <>logo</>;
  }

  return (
    <Link component={RouterLink} to="/" sx={{ display: 'contents' }}>
      {/* <Image
        disabledEffect
        visibleByDefault
        alt="dash"
        src='/logo/logo_full.svg'
        sx={{
          maxWidth: 200, display: 'block',  // Ensures the image is treated as a block element
          margin: 'auto',
        }}
      /> */}

        {logo}

    </Link>
  );
});

ABLogo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default ABLogo;
